import React from "react";
import MyProflie from "container/portfolio/MyProflie";
import MyPortfoiloContent from "container/portfolio/MyPortfoiloContent";
import { getEssentialUrl } from "lib/urlQueryParser";
import { useHistory } from "react-router-dom";

function MyPortfolio(props) {
  const history = useHistory();

  const goToItemUploadMode = () => {
    history.push(getEssentialUrl({ type: "uploadItem" })());
  };

  return (
    <div>
      <MyProflie />
      <MyPortfoiloContent onItemUploadClick={goToItemUploadMode} />
    </div>
  );
}

export default MyPortfolio;
